import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import HighSchoolGraduationTypeService from "../../src/Services/HighSchoolGraduationType.service";
import LookupGeneric from "./lookupGeneric";
const HighSchoolGraduationTypeLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            return HighSchoolGraduationTypeService.findByIds(ids);
        },
        fetchOptions: (query) => {
            return HighSchoolGraduationTypeService.search({
                query,
                active: true, // if HighSchoolGraduationType has an active field for this purpose
            }).then(({ data }) => data);
        },
        optionRenderer: function optionRenderer(highSchoolGraduationType) {
            return _jsx("span", { children: highSchoolGraduationType.name });
        },
    });
};
export default HighSchoolGraduationTypeLookup;
